import { render } from "./ResetPasswordWithEmail.vue?vue&type=template&id=528102e0&scoped=true"
import script from "./ResetPasswordWithEmail.vue?vue&type=script&lang=js"
export * from "./ResetPasswordWithEmail.vue?vue&type=script&lang=js"

import "./ResetPasswordWithEmail.vue?vue&type=style&index=0&id=528102e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528102e0"]])

export default __exports__